import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";
import Layout from "../../components/Layout";

const FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5", "q6"] as const;

const FAQ = () => {
  const { t } = useTranslation(["faq", "common"]);
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Layout title={t("faq:page_title")}>
      <div className="max-w-3xl mx-auto py-4 md:py-8">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-caption text-neon-green mb-3">港微創 · FAQ</p>
          <h1
            className="text-h1 md:text-display text-gradient-brand mb-4"
            style={{ lineHeight: "125%" }}
          >
            {t("faq:page_title")}
          </h1>
          <p
            className="text-body-lg text-gray-400 max-w-2xl mx-auto"
            style={{ lineHeight: "125%" }}
          >
            {t("faq:page_subtitle")}
          </p>
        </div>

        <div className="space-y-3">
          {FAQ_KEYS.map((key, index) => {
            const isOpen = openIndex === index;
            const num = String(index + 1).padStart(2, "0");

            return (
              <div
                key={key}
                className={`rounded-2xl border transition-colors ${
                  isOpen
                    ? "border-neon-green/40 bg-neon-green/5"
                    : "border-white/10 bg-space-light/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  className="w-full flex items-start gap-4 p-5 md:p-6 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="shrink-0 text-caption text-neon-green tabular-nums pt-0.5">
                    {num}
                  </span>
                  <span className="flex-1 text-body font-medium text-white pr-2">
                    {t(`faq:${key}`)}
                  </span>
                  <FaChevronDown
                    className={`shrink-0 text-gray-400 mt-1 transition-transform duration-200 ${
                      isOpen ? "rotate-180 text-neon-green" : ""
                    }`}
                    size={14}
                  />
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <div
                        className="px-5 md:px-6 pb-5 md:pb-6 pl-14 md:pl-16 text-body text-gray-400 leading-relaxed [&_strong]:text-neon-green [&_strong]:font-semibold"
                        dangerouslySetInnerHTML={{
                          __html: t(`faq:a${index + 1}`),
                        }}
                      />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default FAQ;
